import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { defineCustomElements } from "gl-ionic-background-video/dist/loader"; // add this line

const bootStartTs = Date.now();
(window as any).__SWSH_BOOT_T0__ = bootStartTs;
if (!environment.production) {
  console.log(`[PERF][BOOT] main.ts start ${bootStartTs}`);
}

if (environment.production) {
  enableProdMode();

  //Block all console.log logs in prod
  window.console.log = () => { }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    if (!environment.production) {
      const now = Date.now();
      console.log(`[PERF][BOOT] bootstrapModule done +${now - bootStartTs}ms`);
    }
  })
  .catch((err) => console.error(err));

defineCustomElements(window); // call the function here
